export default __webpack_public_path__ + "static/media/crossroads1.7eb82462.webp";